var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniversity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 54,
    viewBox: "0 0 100 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9622 35.4386C49.3317 35.4386 48.7013 35.3603 48.1498 35.2036L21.5928 27.9984V42.8006C21.5928 43.8187 22.1444 44.8369 23.09 45.3068L27.8971 48.1262C34.6741 52.0421 42.3179 54 49.9619 54C57.6059 54 65.1709 52.042 72.0267 48.1262L76.8337 45.3068C77.7794 44.7585 78.331 43.8187 78.331 42.8006V27.9984L51.774 35.2036C51.2224 35.3603 50.592 35.4386 49.9616 35.4386H49.9622Z",
    fill: "#DB0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7951 12.9617L50.7494 0.117477C50.2766 -0.0391591 49.725 -0.0391591 49.1733 0.117477L2.12759 12.9617C0.866742 13.2749 0 14.4497 0 15.7811C0 17.1125 0.866832 18.2873 2.12759 18.6006L8.27421 20.2453V40.6868C6.85576 41.3917 5.91012 42.8797 5.91012 44.5245C5.91012 46.874 7.88029 48.8319 10.2442 48.8319C12.6081 48.8319 14.5783 46.8738 14.5783 44.5245C14.5783 42.8798 13.6326 41.3917 12.2142 40.6868V21.3426L49.2506 31.4458C49.7234 31.6024 50.275 31.6024 50.8267 31.4458L97.8724 18.6016C99.1333 18.2883 100 17.1135 100 15.7821C100 14.4507 99.1332 13.3543 97.7935 12.9627L97.7951 12.9617Z",
    fill: "#DB0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.efb6a35543143b6396bae6ac708a4ad5.svg";
export { ForwardRef as ReactComponent };